import MypageReviewContainer from './MypageReviewContainer';
export default MypageReviewContainer;
